module.exports = __webpack_public_path__ + "static/media/canadian_baby_products_2025_blog.90148d0f.png";